/*
 *   File : upload-cas-qr-code.js
 *   Author : https://evoqins.com
 *   Description : MF import qr code upload component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useState, useEffect } from "react";
import QrScanner from 'qr-scanner'

import { FilePicker } from "../Form-Elements";
import { _checkFileSize } from "../../Helper";
import { PrimaryButton } from "../Buttons";
import { toast } from "react-toastify";
import { APIService } from "../../Service";

function _fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

function UploadQRCodeModal(props) {


    useEffect(() => {
        const _handlePaste = (e) => {
            const files = e.clipboardData.files;
            if (files.length > 0 && files[0].type.startsWith("image/")) {
                _scanQRCodeFile(files[0]);
            }
        };

        window.addEventListener("paste", _handlePaste);

        return () => {
            window.removeEventListener("paste", _handlePaste);
        };
    }, []);

    const [attachedFile, setAttachedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [qrData, setQRData] = useState({});
    const [showSuccessScreen, setShowSuccessScreen] = useState(false);

    const _handleUploadQRCodeImage = async (file) => {
        if (file.target.files.length !== 0) {
            _scanQRCodeFile(file.target.files[0]);
        };
    };

    // scan file
    const _scanQRCodeFile = async (qr_file) => {

        let result;

        try {
            result = await QrScanner.scanImage(qr_file, {
                returnDetailedScanResult: true
            });
        } catch (error) {
            toast.dismiss();
            toast.error("Failed to read QR code. Please try a different image.");
            setAttachedFile(null);
            return;
        }

        const parsedQrData = typeof result.data === 'string'
            ? JSON.parse(result.data)
            : result.data;

        const base64File = (await _fileToBase64(qr_file)).split(",")[1];

        setQRData({
            "reqId": parsedQrData.reqId,
            "clientRefNo": parsedQrData.clientRefNo,
            "qrCode": base64File
        });

        setAttachedFile(qr_file);
    }

    // API call
    const _validateMFImport = () => {
        setLoading(true);
        let is_post = true;
        let api_version = 2;
        let url = 'mf-services/cas/validate-qr  ';
        let token = null;

        APIService(is_post, url, qrData, token, api_version).then((response) => {
            if (response?.status_code === 200) {
                // toast.dismiss();
                // toast.success("Funds will ");
                if (props.type === 2) {
                    // Parent takes over after the upload, no success screen
                    _closeModal();
                } else {
                    setShowSuccessScreen(true);
                }
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setLoading(false);
        });
    };

    const _closeModal = () => {
            let close_modal_btn = document.querySelector("#upload-mf-qr-code-modal-close");
            close_modal_btn.click();

            props.handleSuccessImport();
        }

    return (
        <div className="modal fade e-manage-modal"
            id="upload-mf-qr-code-modal"
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-labelledby="UploadQRCodeModal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                    {
                        props.status !== "success" ?
                            <>
                                <div className="modal-header border-0 justify-content-space-between py-3 px-4 ">
                                    <h6 className='mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px'>
                                        External import failed
                                    </h6>
                                    <img src={require("../../Assets/Images/close-btn.svg").default}
                                        id='upload-mf-qr-code-modal-close'
                                        draggable={false}
                                        className='cursor-pointer'
                                        data-bs-dismiss="modal"
                                        aria-label="close"
                                        alt='close btn'
                                        onClick={props.handleModalClose} />
                                </div>
                                <div className="modal-body pb-4 px-4 py-4">
                                    <img src={require("../../Assets/Images/KYC/kyc-failure.png")}
                                        draggable={false}
                                        className="img-fluid col-5 mx-auto d-block"
                                        aria-label="failed image"
                                        alt='External import failed image' />

                                    <p className="e-font-14-res text-center e-text-red e-alt-font-poppins e-font-18 e-font-weight-600 mt-4 mb-2">
                                        Failed
                                    </p>
                                    <p className="e-font-12-res line-height-20px-res col-sm-10 mx-auto text-center e-text-dark-liver e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px text-center mx-auto mb-0">
                                        External import failed, please try again later.
                                    </p>
                                </div>
                            </>
                            :
                            <>
                                {
                                    showSuccessScreen === true ?
                                        <>
                                            <div className="modal-header border-0 justify-content-space-between py-3 px-4 ">
                                                <h6 className='mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px'>
                                                    Import Request Sent Successfully
                                                </h6>
                                                <img src={require("../../Assets/Images/close-btn.svg").default}
                                                    id='upload-mf-qr-code-modal-close'
                                                    draggable={false}
                                                    className='cursor-pointer'
                                                    data-bs-dismiss="modal"
                                                    aria-label="close"
                                                    alt='close btn'
                                                    onClick={props.handleModalClose} />
                                            </div>
                                            <div className="modal-body pb-4 px-4 py-4">
                                                <img src={require("../../Assets/Images/success.png")}
                                                    draggable={false}
                                                    className="img-fluid col-5 mx-auto d-block"
                                                    aria-label="failed image"
                                                    alt='External import failed image' />

                                                <p className="e-font-14-res text-center  e-alt-font-poppins e-font-18 e-font-weight-600 mt-4 mb-2">
                                                    Funds will appear on your dashboard in 5-8 mins. We will notify you once it is done.
                                                </p>
                                                <PrimaryButton name="View portfolio"
                                                    className="e-font-14-res w-100 padding-12px-top padding-12px-bottom mt-4"
                                                    onPress={_closeModal} />
                                            </div>
                                        </>
                                        : <>
                                            <div className="modal-header border-0 justify-content-space-between py-3 px-4 ">
                                                <h6 className='mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px'>
                                                    Upload or Paste Your QR Code
                                                </h6>
                                                <img src={require("../../Assets/Images/close-btn.svg").default}
                                                    id='upload-mf-qr-code-modal-close'
                                                    draggable={false}
                                                    className='cursor-pointer'
                                                    data-bs-dismiss="modal"
                                                    aria-label="close"
                                                    alt='close btn'
                                                    onClick={props.handleModalClose} />
                                            </div>
                                            <div className="modal-body pb-4 px-4 pt-0">
                                                <div className="d-flex flex-column">

                                                    <div className="mt-3">
                                                        {
                                                            attachedFile !== null ?
                                                                <div className='e-bg-anti-flash-white e-border-radius-12 px-3'>
                                                                    <div className='d-flex gap-2 py-3'>
                                                                        <img src={require("../../Assets/Images/Onboarding/file-upload.svg").default}
                                                                            draggable={false}
                                                                            alt='file-icon' />
                                                                        <p className='e-font-12-res mb-0 e-text-dark-liver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                                                                            {attachedFile.name}
                                                                        </p>
                                                                        <img src={require("../../Assets/Images/KYC/selected-close.svg").default}
                                                                            draggable={false}
                                                                            className='cursor-pointer ms-auto'
                                                                            alt='delete'
                                                                            onClick={() => setAttachedFile(null)} />
                                                                    </div>
                                                                </div>
                                                                :

                                                                <div className="d-flex flex-column justify-content-center align-items-center p-3 e-border-1px-dashed-light-gray e-border-radius-12">

                                                                    <p className="e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-400 line-height-32px mb-4">
                                                                        Past your file(JPG / JPEG / PNG)
                                                                    </p>

                                                                    <FilePicker id="img-proof"
                                                                        label="Select file"
                                                                        type="file"
                                                                        className="w-100"
                                                                        accept=".png, .jpg, .jpeg"
                                                                        file={attachedFile}
                                                                        autoFocus
                                                                        selectFile={_handleUploadQRCodeImage} />
                                                                </div>
                                                        }

                                                    </div>


                                                </div>
                                                {/* Submit button */}
                                                <PrimaryButton name="Submit"
                                                    loading={loading}
                                                    disabled={loading || attachedFile === null ? true : false}
                                                    className="e-font-14-res w-100 padding-12px-top padding-12px-bottom mt-4"
                                                    onPress={_validateMFImport} />
                                            </div>
                                        </>
                                }
                            </>

                    }

                </div>
            </div>
        </div>
    );
};

export default memo(UploadQRCodeModal);